var path = 'app/scripts/modules/appengine/src/pipeline/stages/stopServerGroup/stopServerGroupStepLabel.html';
var html = "<span class=\"task-label\"> Stop Server Group: {{step.context.serverGroupName}} ({{step.context.region}}) </span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;